import {
  TransactionServiceFormRule,
  TransactionServiceFormSchema,
} from "@factory/form/form.rule";
import "./edit-transaction-service.scss";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { useFormDefaultTransactionService } from "@factory/form/form-default-transaction-service.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  GetTransactionServiceModel,
  QueryKeyTransactionService,
} from "@factory/model/query-model-transaction-service";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useQyUpdateTransactionService } from "@factory/query/transaction-service.query";
import FormTransactionService from "../form-transaction-service/form-transaction-service";
import { getFormErrorMessage } from "@shared/utility/get-error-message";
import { Button } from "primereact/button";
import { useQueryClient } from "react-query";

/* eslint-disable-next-line */
export interface EditTransactionServiceProps {
  model: GetTransactionServiceModel;
  onUpdateSuccess?: () => void;
}

export function EditTransactionService({
  model,
  onUpdateSuccess,
}: EditTransactionServiceProps) {
  // LOCAL DECLARATION

  const queryClient = useQueryClient();
  const { showError, showSuccess } = useNotificationContext();
  const { getDefault } = useFormDefaultTransactionService();
  const { mapUpdateTransactionService } = useFormApiMapper();

  // API UPDATE Service
  const handleUpdateApiSuccess = () => {
    showSuccess("Service updated successfully");
    queryClient.invalidateQueries(QueryKeyTransactionService);
    if (onUpdateSuccess) {
      onUpdateSuccess();
    }
  };
  const { mutate: updateService } = useQyUpdateTransactionService(
    handleUpdateApiSuccess
  );

  const formMethod = useForm<TransactionServiceFormSchema>({
    defaultValues: getDefault(model),
    resolver: zodResolver(TransactionServiceFormRule),
  });
  const { handleSubmit } = formMethod;
  const handleValidate = (form: TransactionServiceFormSchema) => {
    if (!model || !model.code) {
      throw new Error("No service data");
    }

    const formData = mapUpdateTransactionService(form, model.code);
    updateService(formData);
  };
  const handleValidateError = (
    err: FieldErrors<TransactionServiceFormSchema>
  ) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="EditTransactionService" className="edit-transaction-service">
      <FormProvider {...formMethod}>
        <FormTransactionService hideAdvanceBooking={true} />
      </FormProvider>
      <section className="flex justify-end mt-8">
        <Button
          label="Update"
          onClick={() => handleSubmit(handleValidate, handleValidateError)()}
        ></Button>
      </section>
    </div>
  );
}

export default EditTransactionService;
